import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';
import SVGError from '../common/assets/svg/icons/SVGError';
import Button, { ButtonStyle } from '../common/components/Button/Button';
import ButtonContainer from '../common/components/Button/ButtonContainer';
import TitleContainer from '../common/components/TitleContainer/TitleContainer';
import UserInfo from '../common/components/UserInfo/UserInfo';

const customStyle = {
  content: {
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    top: '10px',
    minWidth: '400px',
    marginRight: '-50%',
    transform: 'translate(-50%, 0px)',
    background: 'rgb(var(--default-background))',
    borderRadius: '25px',
  },
};

export interface GenericModalProps {
  showModal: boolean;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function GenericModal({ showModal, description, onCancel, onConfirm }: GenericModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <ReactModal isOpen={showModal} style={customStyle}>
      <div className="content-container flex flex-col justify-center items-center flex-grow-0 flex-shrink-0 mt-2 bg-background rounded-3xl">
        <header className="flex-grow-0 flex-shrink-0 flex justify-center items-center my-4">
          <SVGError />
        </header>

        <TitleContainer center>
          <h1 className="mb-4 text-textHeadline" data-testid="GENERIC_MODAL_TITLE">
            {t('screens.confirmationModal.title')}
          </h1>
          <div
            className="leading-6 mb-4 text-textParagraph pass-status-text w-80 text-center"
            data-testid="GENERIC_MODAL_DESCRIPTION"
          >
            {t(description)}
          </div>
        </TitleContainer>

        <ButtonContainer>
          <Button style={ButtonStyle.DEFAULT} dataTestid="RETRY_BUTTON" onClick={onConfirm} disabled={false}>
            <span>{t('screens.confirmationModal.confirmButton')}</span>
          </Button>
          <Button style={ButtonStyle.INVERTED} dataTestid="CLOSE_BUTTON" onClick={onCancel} disabled={false}>
            <span>{t('screens.confirmationModal.cancelButton')}</span>
          </Button>
        </ButtonContainer>
        <UserInfo />
      </div>
    </ReactModal>
  );
}
